import React from "react"
import PropTypes from "prop-types"
import { Header } from "./styles"

export const PageTitle = ({ label, variant }) => {
  const fontsize = variant === "account" ? "pageTitle" : "sectionTitle"

  return (
    <Header variant={variant} fontsize={fontsize}>
      {label}
    </Header>
  )
}

PageTitle.defaultProps = {
  variant: "default",
}

PageTitle.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
}

export default PageTitle
